type RouteDefinition = {
    route: string;
    params?: Record<string, string>;
};

export const AUTH_PASSWORD_RECOVERY_URL = '/password-recovery';
export const AUTH_URL = '/auth';

export const BASE_URL = "/login"

export const getUrl = (url: string) => {
    return BASE_URL + url;
}

export const zitadelRoutes = Object.freeze({
    IDP_INITIALISATION: {
        route: "/idp-init",
        params: {
            BACK_URL: "back-url",
            IDP_NAME: "idp",
        },
    },
    IDP_LANDING: {
        route: "/idp-landing",
        params: {
            INTENT_ID: "id",
            INTENT_TOKEN: "token",
            BACK_URL: "back-url",
            SCHOOL_UNIQUE_KEY: "school",
            IS_REDIRECT_DISABLED: "no-redirect",
        },
    },
    MFA_INITIALISATION: {
        route: "/mfa-initialise",
    },
    TOTP_CHALLENGE: {
        route: "/totp",
    },
    OTP_EMAIL_CHALLENGE: {
        route: "/otp-email",
    },
} as const satisfies Record<string, RouteDefinition>);
